<template>
    <div class="body">
        <p  class="p1" style="padding-top: 8vh;">Hi~ <a class="highlight">{{ ReportData.stuname }}</a></p>
        <p  class="p2" style="padding-top: 1vh;"><a class="highlight">{{ hireday }}</a></p>
        <p  class="p2" >是你开启职场生活的第一天</p>
        <p  class="p2">不知不觉</p>
        <p  class="p2">你在富士康这个大家庭生活工作了<a class="highlight">{{ workdays }}</a>天</p>

        <p class="p3" v-if="ReportData.studate !==null" style="padding-top: 4vh;text-align: center;">你已经学习了<a class="highlight">{{ ReportData.studate }}</a>天</p>
        <p class="p4" v-if="ReportData.playtime !==null" style="text-align: center;">累计学习了<a class="highlight">{{ ReportData.playtime }}</a>小时</p>

        <p class="p2" style="margin: 0 auto;padding-top: 1.5vh;" v-if="ReportData.studate ===null">你还没有在富学宝典上学习<br>请继续加油！</p>
       

        <p class="p5">短短的日子里，你用时间换来了沉淀的厚度</p>
        <p class="p6">这不仅仅是数据，更是你对职业的认真态度</p>

        <p class="p5">每一天学习都是成长的积累，</p>
        <p class="p6">愿你在这里绽放光芒！</p>

        <p class="p10" style="margin-top: 20px;">七月的学习报告已为你生成</p>
        <p class="p10">左滑查看更多内容！</p>
    </div>
</template>
  
<script>

export default {
    props: [ "ReportData"],
    data() {
        return {   
            hireday:'',
            workdays:''
        }
    },
    created() {
        const hiredate = new Date(this.ReportData.hiredate);
        this.hireday = hiredate.toISOString().split('T')[0]; // 显示成 "2025-07-07"

        const today = new Date();
        // 清除时间部分，只保留年月日
        const todayDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
        const hireDateOnly = new Date(hiredate.getFullYear(), hiredate.getMonth(), hiredate.getDate());

        const timeDiff = todayDate - hireDateOnly;
        this.workdays = Math.floor(timeDiff / (1000 * 60 * 60 * 24)) + 1; // 加1表示包含入职当天
    }
}
</script>
  
<style scoped>
.body {
    background: 
                url("../../assets/25July/logo.png") right  top  no-repeat,
                url("../../assets/25May/icon.png") 49% calc(100% + 50px) no-repeat,
                url("../../assets/25July/bg.jpg")  no-repeat;
    background-size:100% 100%, 55%,cover;
    width: 100%;
    height: 100vh;
}
.p1,.p2, .p3, .p4 {
    width: 92%;
    margin: 0;
    text-align: right;
    font-size: 18px;
    color: #000;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.highlight {
	font-size: 24px;
	color: #7126d3;
	text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
	font-weight: bolder;
	font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
 
.p5, .p6, .p7, .p8{
	width: 92%;
	margin: 0;
	text-align: center;
	font-size: 16px;
	color: #000;
	font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}

.p5, .p7{
margin-top: 20px;
}
.p10{
    width: 92%;
    font-size: 15px;
    text-align: center;
    margin: 0;
}
@media screen and (min-width: 786px) {
.body {
    background: 
                url("../../assets/25June/pcbg.jpg")  no-repeat;
    background-size:cover;
    width: 100%;
    height: 100vh;
}
.p1,.p2, .p3, .p4 {
	width: 80%;
	margin: 0 auto;
	text-align: center;
	font-size: 25px;
	color: #000;
	font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.highlight {
	font-size: 26px;
	color: #7126d3;
	text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
	font-weight: bolder;
	font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
 
.p5, .p6, .p7, .p8{
	margin:0 auto;
	text-align: center;
	font-size: 20px;
	width: 92%;
}

.p5, .p7{
	margin-top: 20px;
}
.p10{
    font-size: 18px;
    text-align: center;
    margin: 0;
}
}
@media screen and (min-width: 786px) {
.body {
    background: 
                url("../../assets/25July/pcbg.jpg")  no-repeat;
    background-size:cover;
    width: 100%;
    height: 100vh;
}
.p1,.p2, .p3, .p4 {
	width: 80%;
	margin: 0 auto;
	text-align: center;
	font-size: 25px;
	color: #000;
	font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.highlight {
	font-size: 30px;
	color: #7126d3;
	text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
	font-weight: bolder;
	font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
 
.p5, .p6, .p7, .p8{
	margin:0 auto;
	text-align: center;
	font-size: 20px;
	width: 92%;
}

.p5, .p7{
	margin-top: 20px;
}
}
</style>